import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import ColorChooser from '../../Common/ColorChooser';
import Toggle from '../../Common/Toggle/Toggle';
import Tag from '../../Common/Tag/Tag';

const LocationTagForm = (props) => {
    const onTextChange = (e) => {
        props.onFormChange(e.target.name, e.target.value);
    }

    const onToggleChange = (name, value) => {
        props.onFormChange(name, value);
    }

    const onColorChange = (color) => {
        props.onFormChange("backgroundColor", color);
    }

    const onFormSubmit = (e) => {
        e.preventDefault();
        props.onSubmit();
        return false;
    }

    return (
        <div className="identifier-form">
            <form noValidate className={props.isFormValid ? "" : "was-validated"} onSubmit={onFormSubmit}>
                <InputText name="name" label="Name" placeholder="Name" type="text" value={props.locationTag.name} onChange={onTextChange} isRequired={true} errorMessage="Name is required" />
                <div className="mt-2 mb-4">
                    <Toggle name="isActive" text="Active" checked={props.locationTag.isActive} onChange={onToggleChange} />
                </div>
                <ColorChooser
                    name="backgroundColor"
                    title="Background Color"
                    selectedColor={props.locationTag.backgroundColor}
                    onChange={onColorChange}
                />
                <div className="mt-5">
                    <span className="me-2">Preview:</span>
                    <Tag 
                        title={props.locationTag.name} 
                        backgroundColor={props.locationTag.backgroundColor}
                    />
                </div>
            </form>
        </div>
    );
}


LocationTagForm.propTypes = {
    onFormChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    locationTag: PropTypes.object
}

export default LocationTagForm;
